export interface XeroErrorDetails {
  errorStatusCode?: number;
  errorBody?: string;
  errorMessage?: string;
  errorCode?: string;
  errorName?: string;
  errorStack?: string;
}

/** xero-node rejects failed requests with a JSON string like `{"response":{"statusCode":429,...}}` */
function parseStatusCodeFromString(error: unknown): number | undefined {
  if (typeof error !== 'string') return undefined;
  try {
    return JSON.parse(error)?.response?.statusCode;
  } catch {
    return undefined;
  }
}

export function extractXeroErrorDetails(error: any): XeroErrorDetails {
  const errorStatusCode =
    error?.response?.statusCode ??
    error?.response?.status ??
    error?.statusCode ??
    error?.status ??
    parseStatusCodeFromString(error);
  const rawBody = typeof error === 'string' ? error : error?.response?.body ?? error?.response?.text ?? error?.body;
  const errorBody = rawBody ? (typeof rawBody === 'string' ? rawBody : JSON.stringify(rawBody, null, 2)) : undefined;

  return {
    errorStatusCode,
    errorBody,
    errorMessage: error?.message,
    errorCode: error?.code,
    errorName: error?.name,
    errorStack: error?.stack,
  };
}
